import { render, staticRenderFns } from "./monthlysales_details.vue?vue&type=template&id=0ef5c1de"
import script from "./monthlysales_details.vue?vue&type=script&lang=js"
export * from "./monthlysales_details.vue?vue&type=script&lang=js"
import style0 from "./monthlysales_details.vue?vue&type=style&index=0&id=0ef5c1de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports